(ns iris.route-data.events
  (:require
   [re-frame.core :as re-frame]
   [re-frame.db :as re-frame-db]
   [iris.analytics.route-data :as analytics-route-data]
   [iris.censors.route-data :as censors-route-data]
   [iris.logs.route-data :as logs-route-data]
   [iris.posts.route-data :as posts-route-data]
   [iris.route-scroll :as route-scroll]
   [iris.screens.route-data :as screens-route-data]
   [iris.search.route-data :as search-route-data]
   [reagent.core :as reagent]))


(def panel-loaders
  (merge analytics-route-data/panel-loaders
         censors-route-data/panel-loaders
         posts-route-data/panel-loaders
         logs-route-data/panel-loaders
         search-route-data/panel-loaders
         screens-route-data/panel-loaders))

(defonce route-scroll-run-id (atom 0))

(def force-pq-load-events
  #{:iris.posts.events/http-get-latest-post-list
    :iris.posts.events/http-get-post-list
    :iris.posts.events/http-get-post-list-batch
    :iris.posts.events/http-get-post-list-batch-debounced
    :iris.posts.events/http-get-header-flow})

(defn force-post-list-effect [effect]
  (if (and (contains? force-pq-load-events (first effect))
           (map? (second effect)))
    (update effect 1 #(with-meta (assoc % :pq-check false) (meta %)))
    effect))

(defn after-next-paint! [f]
  (.requestAnimationFrame
   js/window
   (fn []
     (.requestAnimationFrame js/window f))))


(defn sync-route-data-effects
  ([db route] (sync-route-data-effects db route nil))
  ([db route {:keys [force?]}]
   (let [panel (:panel route)
         route-rev (:route-rev route)]
     (if-let [{:keys [params-fn load-key-fn effects-fn load-start-fn load-start-db-fn
                      tag-load-fn same-load-effects-fn]} (get panel-loaders panel)]
       (if-let [query-params (params-fn db route)]
         (let [load-key (load-key-fn query-params)
               cached-load (get-in db [:route-data :loads panel])
               same-panel? (= panel (get-in db [:prev-route :panel]))
               same-route-rev? (= route-rev (:route-rev cached-load))
               same-load? (= load-key (:load-key cached-load))]
           (if (and same-route-rev? same-load? (not force?))
             {:db db}
             (let [route-load {:panel panel
                               :route-rev route-rev
                               :load-key load-key}
                   query-params (cond-> query-params
                                  tag-load-fn
                                  (tag-load-fn route-load))
                   effects (cond->> (effects-fn query-params)
                             (and same-load? same-panel? (not force?) same-load-effects-fn)
                             same-load-effects-fn
                             force?
                             (map force-post-list-effect))
                   load-start-effect (when load-start-fn
                                       (load-start-fn {:panel panel
                                                       :previous-panel (get-in db [:prev-route :panel])
                                                       :route-rev route-rev
                                                       :load-key load-key
                                                       :same-load? (and same-load? (not force?))
                                                       :same-route-rev? same-route-rev?
                                                       :query-params query-params
                                                       :effects effects}))
                   db' (cond-> (assoc-in db [:route-data :loads panel]
                                         {:route-rev route-rev
                                          :load-key load-key})
                         (and load-start-effect load-start-db-fn)
                         (load-start-db-fn (second load-start-effect)))
                   dispatches (cond->> effects
                                (and load-start-effect (not load-start-db-fn))
                                (cons load-start-effect))]
               {:db db'
                :dispatch-n (vec dispatches)})))
         {:db db})
       {:db db}))))


(re-frame/reg-event-fx
 ::sync-route-data
 (fn [{:keys [db]} [_ route]]
   (sync-route-data-effects db route)))

(re-frame/reg-event-fx
 ::force-sync-route-data
 (fn [{:keys [db]} _]
   (let [{:keys [db dispatch-n]} (sync-route-data-effects db (:route db) {:force? true})]
     {:db db
      :dispatch-n dispatch-n})))

(re-frame/reg-fx
 :sync-route-data-and-scroll
 (fn [route]
   (let [{:keys [db dispatch-n]} (sync-route-data-effects @re-frame-db/app-db route)]
     (reset! re-frame-db/app-db db)
     (route-scroll/begin-navigation!)
     (doseq [event dispatch-n]
       (re-frame/dispatch event))
     (let [run-id (swap! route-scroll-run-id inc)]
       (reagent/after-render
        #(when (= run-id @route-scroll-run-id)
           (after-next-paint!
            (fn []
              (when (= run-id @route-scroll-run-id)
                (route-scroll/navigate-route! route))))))))))
